// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"value-prop-step_listContainer_178","listItem":"value-prop-step_listItem_1cp"};